import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LocationFilterEvent } from '../models/location-filter-event.model';
import { ModalService } from '../modals/modal.service';
import { SessionService } from '../services/session.service';
import { Utils } from '../utils/utils';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

declare var $:any;

@Component({
    selector: 'location-filter',
    templateUrl: 'location-filter.component.html',
    standalone: false
})
export class LocationFilterComponent implements OnInit {

    @Output()onFilter: EventEmitter<LocationFilterEvent> = new EventEmitter<LocationFilterEvent>();

    public soonestAvail: boolean = false;
    public onBy: string = 'on';
    public filterDate: string = 'mm / dd / yyyy';
    public numAppts: string = '';

    constructor(private modalService: ModalService,
                private session: SessionService,
                private translate: TranslateService) {}

    ngOnInit() {
        var self: LocationFilterComponent = this;
        $('.date-widget-field').datepicker({
            onSelect: function(date: any) {
                self.filterDate = date;
                self.soonestAvail = false;
            }
        });
        this.translate.onLangChange.subscribe((res: LangChangeEvent) => {
            if (isNaN(Date.parse(this.filterDate))) {
                if (res.lang === 'es') {
                    this.filterDate = 'mm / dd / aaaa';
                } else if (res.lang === 'fr') {
                    this.filterDate = 'mm / jj / aaaa';
                } else {
                    this.filterDate = 'mm / dd / yyyy';
                }
            }
        });
    }

    public applyFilter() {
        let event: LocationFilterEvent = new LocationFilterEvent();
        if (this.soonestAvail) {
            event.soonestAvailable = true;
            this.session.filterSoonest = true;
        } else {
            // check the date
            event.on = this.onBy === 'on';
            event.by = this.onBy === 'by';
            if (Utils.isValidShortDateString(this.filterDate)) {
                event.filterDate = new Date(this.filterDate);
                if (event.on) {
                    this.session.filterDate = this.filterDate;
                    this.session.filterSoonest = false;
                } else {
                    this.session.filterDate = null;
                    this.session.filterSoonest = true;
                }
            } else {
                this.modalService.warn('ERROR_MESSAGES.INVALID_DATE');
            }
        }

        if (!isNaN(Number(this.numAppts))) {
            event.numberOfAppointments = Number(this.numAppts);
            this.session.numberOfAppointments = Number(this.numAppts);
        }

        if (event.numberOfAppointments === undefined || event.numberOfAppointments === null || this.numAppts === '') {
            event.numberOfAppointments = 1;
        }

        // check that their is something to filter
        if ((event.soonestAvailable || event.filterDate) && event.numberOfAppointments) {
            this.onFilter.emit(event);
        }
    }

    public resetFilter() {
        this.soonestAvail = false;
        this.onBy = 'on';
        this.filterDate = null;
        this.numAppts = '';
        this.onFilter.emit(new LocationFilterEvent(false, false, false, null, null, true));
    }

}
